import * as APPDATA from '@/constants/pcConstAppData';

/**
 * @deprecated
 * this app is already using log level
 */
export const consoleLog = (text, ...data) => {
  if (APPDATA.CONFIGURATION.IS_DEVELOPMENT_MODE) {
    console.log(text, ...data);
  }
};

/**
 * @deprecated
 * this app is already using log level
 */
export const consoleDebug = (text, ...data) => {
  if (APPDATA.CONFIGURATION.IS_DEVELOPMENT_MODE) {
    console.debug(text, ...data);
  }
};

/**
 * @deprecated
 * this app is already using log level
 */
export const consoleError = (text, ...data) => {
  if (APPDATA.CONFIGURATION.IS_DEVELOPMENT_MODE) {
    console.error(text, ...data);
  }
};
